import { get, set } from 'idb-keyval';
import { v4 as uuidv4 } from 'uuid';

const DEVICE_ID_KEY = 'device_id';

export const getOrCreateDeviceUUID = async (): Promise<string> => {
  let uuid = await get(DEVICE_ID_KEY);
  if (!uuid) {
    uuid = uuidv4();
    await set(DEVICE_ID_KEY, uuid);
  }
  return uuid;
};